import { GeistSans } from 'geist/font/sans'
import { GeistMono } from 'geist/font/mono'
import { cabinetGrotesk } from '@/fonts/cabinetGrotesk'
import type { SiteFonts } from '../../types'

/*
 * D-1 (owner, 2026-09-17): GeistSans for body, cabinetGrotesk for display.
 * GeistMono is kept ONLY for the header top utility bar — the one exception.
 * `fonts.className` is applied by the root layout.
 */
export const sans = GeistSans
export const display = cabinetGrotesk
export const mono = GeistMono

export const fonts: SiteFonts = {
  className: [GeistSans.variable, cabinetGrotesk.variable, GeistMono.variable]
    .filter(Boolean)
    .join(' '),
}
